import IconButton from "@/components/IconButton";
import { DateTime } from "luxon";

type Props = {
  month: DateTime;
  onChange(month: DateTime): void;
};

export default function MonthPager({ month, onChange }: Props) {
  const selected = month.startOf("month");
  const currentMonth = DateTime.now().startOf("month");
  const nextDisabled = selected >= currentMonth;
  const monthLabel = selected.toFormat("LLLL yyyy");

  return (
    <nav className="flex items-center" aria-label="Audit log month">
      <IconButton
        name="chevron_left"
        ariaLabel={`Previous month from ${monthLabel}`}
        onClick={() => onChange(selected.minus({ months: 1 }))}
      />
      <span
        id="audit-log-month-label"
        className="text-title-medium min-w-[148px] text-center"
        aria-live="polite"
        aria-atomic="true"
      >
        {monthLabel}
      </span>
      <IconButton
        name="chevron_right"
        ariaLabel={`Next month from ${monthLabel}`}
        disabled={nextDisabled}
        onClick={() => onChange(selected.plus({ months: 1 }))}
      />
    </nav>
  );
}
